import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Header from "../App/Header/Header";
import AddCircleOutlineIcon from 'mdi-react/AddCircleOutlineIcon';
import FormTypeList from "./FormTypeList/FormTypeList";
import FormTypeModal from "./FormTypeModal/FormTypeModal";
import { useToggle } from "../../hooks";
import './FormType.scss';

const FormTypes = ({ user }) => {
  const [showModal, toggleShowModal] = useToggle(false);
  const [shouldRefresh, toggleShouldRefresh] = useToggle(false);

  const handleCloseModal = () => {
    toggleShowModal();
    toggleShouldRefresh();
  }

  return (
    <>
      <Header user={user} title={"Forms"} />
      <Container className="MainContent">
        <Row className="mb-3">
        {/* <Button
            variant="link"
            className="pl-0"
            onClick={() => history.goBack()}
          >
            <span className="material-icons md-18">arrow_back</span>
            Back
          </Button> */}
          <Col xs={12} className="mb-3 sticky-form-type-div pb-5">
            {/* <span className="h2LikeStyle">Forms: </span> */}
            <Button
              variant="default"
              className=" btn btn-success-deal-style roundedEdges"
              size="xs"
              onClick={toggleShowModal}
            >
              <AddCircleOutlineIcon className="p-1" />
              <span className="lillteDown">Add Form Type</span>
            </Button>
          </Col>
            <Col xs={12} className="mt-3">
              <FormTypeList refresh={shouldRefresh} user={user}/>
            </Col>
          
        </Row>
        <FormTypeModal show={showModal} onClose={handleCloseModal} />
      </Container>
    </>
  );
}

export default FormTypes;
